/**
* Created by kongwm.kong on 2017/7/26.
*/
<template>
    <div>
        <modal name="msgModal" :width="340" height="auto" @closed="hide">
            <div class="vue-modal-wrap">
                <div class="modal-title">提示信息<span @click="hide">x</span></div>
                <div class="modal-bd">{{msg}}</div>
            </div>
        </modal>
    </div>
</template>
<script>
    export default {
        computed:{
            msg(){
                if(this.$store.state.msg !== ''){
//                    this.hide();
                    this.show();
                }
                return this.$store.state.msg;
            }
        },
        data(){
            return {

            }
        },
        methods : {
            show(){
                this.$modal.show('msgModal');
            },
            hide(){
                this.$store.commit('msg', '');
                this.$modal.hide('msgModal');

            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    .vue-modal-wrap{
        @include bgff;
        width:340px;
        .modal-bd{
            padding: 40px 50px ;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/modal/msgModal.vue